export const LEGACY_AUTH_REQUIRED_KEY = 'atom.legacy.auth.required';
